import { Card } from "./Shapes/Card";
import { ImgCard } from "./Shapes/ImgCard";
import { FlowShape, flowShapes } from "./Shapes/FlowShape";
import { TextShape } from "./Shapes/TextShape";
import { CustomShape } from "./Shapes/CustomShape";
import { TopicShape } from "./Shapes/TopicShape";
import { IBaseShape, ItemConfig, ICustomShapeConfig } from "../types";

export const shapes = {
	card: Card,
	"img-card": ImgCard,
	text: TextShape,
	topic: TopicShape,
};

for (const key in flowShapes) {
	shapes[key] = FlowShape;
}

export function shapesFactory(config: ItemConfig, parameters?): IBaseShape {
	let component = shapes[config.type];
	if (!component) {
		component = shapes.card;
		if (parameters.shapes[config.type]) {
			return new CustomShape(config as ICustomShapeConfig, parameters);
		}
	}
	return new component(config, parameters);
}
